<template>
    <ol-vector-layer :zIndex="5" >
        <ol-source-vector v-if="features && format" :format="GeoJSONformat" :features="features">
            <ol-style :overrideStyleFunction="overrideStyleFunction">
            </ol-style>
        </ol-source-vector>
    </ol-vector-layer>

</template>



<script setup>
import { ref, inject, onMounted } from 'vue'
import { useRuntimeStore } from '@/store/runtime';
const runtimeStore = useRuntimeStore();
import { useDataStore } from '@/store/data';
const dataStore = useDataStore();


import * as olExtent from 'ol/extent';

import { Circle, Fill, Stroke, Style, RegularShape} from 'ol/style.js';
import { Point } from 'ol/geom.js';
import { Text } from 'ol/style.js';

const props = defineProps({
    which: {
        type: String,   // annotazioni_colleghi, annotazioni_personali
        required: true,
    },
})


import GeoJSON from 'ol/format/GeoJSON.js'


const format = inject("ol-format")

const GeoJSONformat = new format.GeoJSON()


// const features = ref(dataStore.userData[props.which].features)
const features = ref([])
const featuresFromLocalstorage = JSON.parse(localStorage.getItem(props?.which))


const readData = async () => {


    
    const geoJSONFromLocalStorage = {
    "type": "FeatureCollection",
    "features": featuresFromLocalstorage,
    }

    

    features.value = new GeoJSON().readFeatures(geoJSONFromLocalStorage, {
        dataProjection: "EPSG:4326",   // 4326 is geojson default/standard
        featureProjection: "EPSG:3857",   // that should be view(map) projection
    })
}


onMounted(() => {
    setTimeout(() => { readData() }, 100)
})



const glyphs  = {
   "star": "󰓎",
    "heart": "󰋑",
    "flag": "󰈻",
    "eye": "󰈈",
    "alert": "󰀦",
    "information": "󰋼",
    "check": "󰄬",
    "close": "󰅖",
    "map": "󰍎",
    "magnify": "󰍉",
}


const regularFontSize = 60
const zIndex = ref(1)






// colors

const coolBlue = "#00aaff"
const black = "#000000"
const darkGrey = "#666666"
const lightGrey = "#aaaaaa"
const shadowColor = "#00000044"


const greenyellow = "red"
const colleghi = "orange"
const personali = "yellow"

let annotationColor = personali

if (props.which === "annotazioni_colleghi") {
    annotationColor = colleghi
}




/* eslint-disable no-unused-vars */
const overrideStyleFunction = (feature, style, resolution) => {

    const note =         feature.get('note');
    const priority =     feature.get('priority');
    const codice =       feature.get('codice');
    const color =        feature.get('color');
    const segnalatore =  feature.get('segnalatore');
    const icon =         feature.get('icon');
    const id =           feature.get('id');
    const pubblico =     feature.get('public');
    const uuid =         feature.get('uuid');


    const geometry = feature.getGeometry();
    const gExt = geometry.getExtent()
    const centerPoint = olExtent.getCenter(gExt)
    const centerPointError = [centerPoint[0], centerPoint[1] - 32 * resolution]
    const centerPointShadow = [centerPoint[0], centerPoint[1] - 3 * resolution]


    // // 5798522 is maximum y coordinate (much over vda)

    // // miny of 
    // // Extent{Array.<number>}
    // // An array of numbers representing an extent: [minx, miny, maxx, maxy].
    const miny = gExt[1]
    // // console.log(`label, y: ${label}, ${miny}`)
    // // main_style.setZIndex(miny)

    if (!props.selected) {
        zIndex.value = 5798522 - parseInt(miny)
    }

    if (props.selected) {
        zIndex.value = 5798522
    }



    const fillShadow = new Fill({
        color: shadowColor
    })

    let fillColor = "#ffffff"


    // character = "aaa"

    let radius = 18
    let mainIconFontSize = regularFontSize



    // console.log(fillColor)

    const fill = new Fill({
        color: fillColor,
    });


    const fillLinesFar = new Fill({
        color: "#333333",
    });




    const strokeBlack = new Stroke({
        color: coolBlue,
        width: 3,
    });


    // console.log(layer.value.name)
    fill.setColor("red")
    const new_styles = []
    const main_style =
        new Style({
            text: new Text({
                // font: '20px sans-serif',
                // textAlign: 'center',
                // textBaseline: 'bottom',
                // text: model,
                // // text: dataModel?.emoji,
                // text: zIndex.value
            })
        })


    if (geometry.getType() === "Point") {


        let fillColor = annotationColor


        let offsetY = 0

        
        offsetY = -mainIconFontSize / 2.5
        
        let actualGliph = glyphs["star"]
        const pointGlyphSelected = actualGliph
        
        if (props.selected) {
            fillColor = greenyellow
            // selectedIndex = 10000
            actualGliph = pointGlyphSelected
        }

        main_style.setStroke(strokeBlack)


        const shadow_style =
            new Style({
                geometry: new Point(centerPointShadow),
                image: new Circle({
                    fill: fillShadow,
                    radius: 15,
                    scale: [1, 0.6],
                }),
                zIndex: 1,
            })

        new_styles.push(shadow_style)





        // main_style.setText(character)

        // debugger

        main_style.getText().setFont(`normal normal normal ${mainIconFontSize}px/1 "Material Design Icons"`);
        // set color
        main_style.getText().setFill(new Fill({
            color: fillColor
        }));
        main_style.getText().setStroke(new Stroke({
            color: "black",
            width: 5
        }));
        main_style.getText().setTextAlign('center')
        main_style.getText().setTextBaseline('middle')
        main_style.getText().setPlacement('point')
        main_style.getText().setOffsetX(0)
        main_style.getText().setRotation(0)

        main_style.getText().setOffsetY(offsetY)
        main_style.getText().setText(actualGliph)

        new_styles.push(main_style)




        if (icon) {
            
            // a_icon_style additional icon style
        // "icon" property of feature is set by user, and can be used to display a second icon on top of the main one, for example to indicate a category or a status
         offsetY = -mainIconFontSize / 2.6

         const a_icon_FontSize = mainIconFontSize / 3

         const a_icon_style =
            new Style({
                geometry: new Point(centerPoint),
                text: new Text({       })
            })
            // a_icon_style.setText(character)

        // debugger
        a_icon_style.getText().setText(glyphs[icon])
        a_icon_style.getText().setFont(`normal normal normal ${a_icon_FontSize}px/1 "Material Design Icons"`);
        // set color
        a_icon_style.getText().setFill(new Fill({
            color: "#000"
        }));
        a_icon_style.getText().setStroke(new Stroke({
            color: "#fff0",
            width: 0
        }));
        a_icon_style.getText().setTextAlign('center')
        a_icon_style.getText().setTextBaseline('middle')
        a_icon_style.getText().setPlacement('point')
        a_icon_style.getText().setOffsetX(0)
        a_icon_style.getText().setRotation(0)

        a_icon_style.getText().setOffsetY(offsetY)
        
        new_styles.push(a_icon_style)

        } 
        
        





    }






    new_styles.forEach((s) => s.setZIndex(zIndex.value))


    return new_styles

};



</script>
